import product from './Product';
import rect from './Rect';
import round from './Round';
import row from './Row';
import text from './Text';
import custom from './Custom';
export default {
  product: product,
  custom: custom,
  rect: rect,
  round: round,
  row: row,
  text: text
};